import { useEffect } from 'react';

import { useInterestsActions } from './InterestsContext';

import { getInterests } from './restApi';

const InterestsLoader = ({ authenticatedUser }) => {
  const { initializeState, onResponse, onError } = useInterestsActions();

  useEffect(() => {
    initializeState(authenticatedUser);
  }, []);

  useEffect(() => {
    getInterests({
      onResponse,
      onError,
      pageNumber: 1,
    });
  }, []);

  return null;
};

export default InterestsLoader;
